import React, { useEffect, useState } from 'react'
import { Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import Badge from '@mui/material/Badge';
import RefreshIcon from '@mui/icons-material/Refresh';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import UpdateDisabledIcon from '@mui/icons-material/UpdateDisabled';
import UpdateIcon from '@mui/icons-material/Update';
export interface IMrtRefreshCounterProps{
    refreshFn: any;
    title:string;
    enable:string;
}

export default function MrtRefreshCounter({refreshFn, title, enable} : IMrtRefreshCounterProps) {
  const [second, setSecond] = useState(0);
  const [resetInterval, setResetInterval] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(second);

  const onChangeSecond = (s: number) => {
    setRefreshCounter(s);
    setSecond(s);
    handleClose();
  }

    useEffect(() => {
        if(enable === "false" || second === 0) return;
        
        let s = second;
        const interval = setInterval(() => {
          setRefreshCounter(refreshCounter => {s = refreshCounter ; return refreshCounter - 1});
          if(s <= 1){
            refreshFn();
            clearInterval(interval);
            setResetInterval(!resetInterval);
            setRefreshCounter(second);
          }
        }, 1000);
  
        return () => {
          clearInterval(interval);
        };
      }, [resetInterval, second]);

      // menu :
      const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
      const open = Boolean(anchorEl);
      const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
  return (
    <Box sx={{ display: 'flex', gap: '0.5rem' }}>
      <Tooltip arrow title={title}>
        <Badge color="secondary" badgeContent={enable === "false" ? 0 : refreshCounter}>
            <IconButton onClick={() => {setRefreshCounter(second); refreshFn()}} size='small'>
                <RefreshIcon />
            </IconButton>
        </Badge> 
      </Tooltip>
    {enable === "true" && 
      <Tooltip arrow title='تنظيم بازخواني' >
          <IconButton onClick={handleClick} size='small'>
              <ManageHistoryIcon />
          </IconButton>
      </Tooltip>
    }
    {enable === "true" && 
      <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={() => onChangeSecond(60)}>
            <ListItemIcon>
              <UpdateIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>60 ثانيه </ListItemText>
          </MenuItem>
          <MenuItem onClick={() => onChangeSecond(45)}>
            <ListItemIcon>
              <UpdateIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>45 ثانيه </ListItemText>
          </MenuItem>
          <MenuItem onClick={() => onChangeSecond(30)}>
            <ListItemIcon>
              <UpdateIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>30 ثانيه</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => onChangeSecond(0)}>
            <ListItemIcon>
              <UpdateDisabledIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>غير فعال</ListItemText>
          </MenuItem>
        </Menu>
      }
      </Box>
  )
}
